import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { SuspenseWrapper } from '../../components/Loading/SuspenseWrap';
import SurveyManagement from './SurveyManagement/view';
import SurveyDetail from './SurveyManagement/detail/detail-index';
import PushNotification from './PushNotification/view';
import AnswerList from './AnswerList';
import VoucherManagement from './Voucher/view';
import VoucherDetail from './Voucher/detail/detail-index';
import PostManagement from './PostManagement/view';
import PostDetail from './PostManagement/detail/detail-index';
import NotFound from '../Notfound';
import TriviaAccess from './TriviaAccess/view';
import TriviaDetail from './TriviaAccess/detail/detail-index';
import BloodTypeDestiny from './BloodTypeDestiny/view';
import BtdDetail from './BloodTypeDestiny/detail/detail.index';
import LifeHack from './LifeHack/view';
import LifehackDetail from './LifeHack/detail/detail-index';
import OnThisDay from './OnThisDay/view';
import OnThisDayDetail from './OnThisDay/detail/detail-index';
import Painting from './Painting/view';
import PaintingDetail from './Painting/detail/detail-index';

const Admin = React.lazy(() => import('./index'));
const ListCustomer = React.lazy(() => import('./Customer/ListCustomer'));
const ListRole = React.lazy(() => import('./Role/ListRole'));
const CreateRole = React.lazy(() => import('./Role/CreateEditRole'));
const SignInAdmin = React.lazy(() => import('./Auth/SignIn'));

const AdminRoutes = () => (
  <Routes>
    <Route path="signin" element={<SuspenseWrapper component={<SignInAdmin />} />} />
    <Route path="" element={<SuspenseWrapper component={<Admin />} />}>
      <Route path="survey-management" element={<SuspenseWrapper component={<SurveyManagement />} />} />
      <Route path="survey-management/create" element={<SuspenseWrapper component={<SurveyDetail />} />} />
      <Route path="survey-management/:id" element={<SuspenseWrapper component={<SurveyDetail />} />} />

      <Route path="push-notifications" element={<SuspenseWrapper component={<PushNotification />} />} />

      <Route path="answer-list" element={<SuspenseWrapper component={<AnswerList />} />} />

      <Route path="e-voucher" element={<SuspenseWrapper component={<VoucherManagement />} />} />
      <Route path="e-voucher/create" element={<SuspenseWrapper component={<VoucherDetail />} />} />
      <Route path="e-voucher/:id" element={<SuspenseWrapper component={<VoucherDetail />} />} />

      <Route path="post-management" element={<SuspenseWrapper component={<PostManagement />} />} />
      <Route path="post-management/create" element={<SuspenseWrapper component={<PostDetail />} />} />
      <Route path="post-management/:id" element={<SuspenseWrapper component={<PostDetail />} />} />

      <Route path="trivia-access" element={<SuspenseWrapper component={<TriviaAccess />} />} />
      <Route path="trivia-access/create" element={<SuspenseWrapper component={<TriviaDetail />} />} />
      <Route path="trivia-access/:id" element={<SuspenseWrapper component={<TriviaDetail />} />} />

      <Route path="fortune_telling" element={<SuspenseWrapper component={<BloodTypeDestiny />} />} />
      <Route path="fortune_telling/create" element={<SuspenseWrapper component={<BtdDetail />} />} />
      <Route path="fortune_telling/:id" element={<SuspenseWrapper component={<BtdDetail />} />} />

      <Route path="life-hack" element={<SuspenseWrapper component={<LifeHack />} />} />
      <Route path="life-hack/create" element={<SuspenseWrapper component={<LifehackDetail />} />} />
      <Route path="life-hack/:id" element={<SuspenseWrapper component={<LifehackDetail />} />} />

      <Route path="on-this-day" element={<SuspenseWrapper component={<OnThisDay />} />} />
      <Route path="on-this-day/create" element={<SuspenseWrapper component={<OnThisDayDetail />} />} />
      <Route path="on-this-day/:id" element={<SuspenseWrapper component={<OnThisDayDetail />} />} />

      <Route path="painting" element={<SuspenseWrapper component={<Painting />} />} />
      <Route path="painting/create" element={<SuspenseWrapper component={<PaintingDetail />} />} />
      <Route path="painting/:id" element={<SuspenseWrapper component={<PaintingDetail />} />} />

      <Route path="customers" element={<SuspenseWrapper component={<ListCustomer />} />} />
      <Route path="*" element={<NotFound />} />
      <Route path="roles">
        <Route path="" element={<SuspenseWrapper component={<ListRole />} />} />
        <Route path="create" element={<SuspenseWrapper component={<CreateRole />} />} />
        <Route path="detail/:id" element={<SuspenseWrapper component={<CreateRole />} />} />
      </Route>
    </Route>
  </Routes>
);

export default AdminRoutes;
